import { render } from "./indetail.vue?vue&type=template&id=0531862b&scoped=true"
import script from "./indetail.vue?vue&type=script&lang=js"
export * from "./indetail.vue?vue&type=script&lang=js"

import "./indetail.vue?vue&type=style&index=0&id=0531862b&scoped=true&lang=css"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0531862b"]])

export default __exports__